<template>
  <div class="apartment-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/apartment/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span
        ><img
          style="width: 150px"
          src="../../../assets/images/apartment/logo.png"
          alt=""
      /></span>
    </p>
    <div class="section-container intro-box-content">
      <p>秉承“好房子·漫生活”的品牌主张，</p>
      <p>
        我们于2018年推出长租公寓自有品牌：<span
          style="font-size: 16px; color: rgb(0, 0, 0)"
          ><strong
            style="text-align: center; white-space: normal; font-weight: 700"
            >新希望·新家 NEO H</strong
          ></span
        ><strong
          style="text-align: center; white-space: normal; font-weight: 700"
          ><span style="color: rgb(227, 108, 9); font-size: 20px">O</span
          ><span style="font-size: 20px; color: rgb(247, 150, 70)"></span
          ><span style="font-size: 16px; color: rgb(0, 0, 0)">ME</span></strong
        >
      </p>
      <p>主要服务于20-40岁的城市菁英，</p>
      <p>为租客打造全方位的租住生活服务空间。</p>
      <p><br /></p>
      <p>承袭新希望星级酒店的运营服务经验，</p>
      <p>带来精细化社群分类体验，</p>
      <p>融合“住、商、社交、服务”的生态化联动，</p>
      <p>覆盖城市客户的全联互动需求。</p>
      <p><br /></p>
      <p>
        <span style="font-size: 16px; color: rgb(0, 0, 0)"
          ><strong
            style="text-align: center; white-space: normal; font-weight: 700"
            >新希望·新家 NEO H</strong
          ></span
        ><strong
          style="text-align: center; white-space: normal; font-weight: 700"
          ><span style="color: rgb(227, 108, 9); font-size: 20px">O</span
          ><span style="font-size: 20px; color: rgb(247, 150, 70)"></span
          ><span style="font-size: 16px; color: rgb(0, 0, 0)">ME</span></strong
        >
      </p>
      <p>以新锐居住空间开启新潮生活方式，</p>
      <p>让城市生活更有温度。</p>
    </div>
    <div
      class="section-container swiper-container wow animate__fadeIn"
      data-wow-duration="500ms"
      style="--swiper-theme-color: #000"
    >
      <div class="swiper-box" ref="headerSwiperRef">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img
              :src="item"
              alt="轮播图"
              style="width: 100%; cursor: pointer"
            />
          </div>
        </div>
      </div>
      <div class="swiper-button-prev swiper-button"></div>
      <div class="swiper-button-next swiper-button"></div>
    </div>

    <div class="section-container mt65">
      <el-row>
        <el-col
          :span="24"
          class="wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <div class="apartment-box">
            <img
              src="../../../assets/images/apartment/bg1.jpg"
              alt=""
            />
            <div
              class="apartment-text wow animate__slideInUp"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <img
                src="../../../assets/images/apartment/icon1.png"
                alt=""
              />
              <p>品质居所</p>
              <p>时尚与品质并重的装修</p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="24"
          class="wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <div class="apartment-box">
            <img
              src="../../../assets/images/apartment/bg2.jpg"
              alt=""
            />
            <div
              class="apartment-text wow animate__slideInUp"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <img
                src="../../../assets/images/apartment/icon2.png"
                alt=""
              />
              <p>生活聚落</p>
              <p>完善的大尺度公区配套</p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="24"
          class="wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <div class="apartment-box">
            <img
              src="../../../assets/images/apartment/bg3.jpg"
              alt=""
            />
            <div
              class="apartment-text wow animate__slideInUp"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <img
                src="../../../assets/images/apartment/icon3.png"
                alt=""
              />
              <p>舒适智家</p>
              <p>完善的智能家居配置</p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="24"
          class="wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <div class="apartment-box">
            <img
              src="../../../assets/images/apartment/bg4.jpg"
              alt=""
            />
            <div
              class="apartment-text wow animate__slideInUp"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <img
                src="../../../assets/images/apartment/icon4.png"
                alt=""
              />
              <p>27-93m²</p>
              <p>突破公寓边界</p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="24"
          class="wow animate__fadeIn"
          data-wow-duration="500ms"
        >
          <div class="apartment-box">
            <img
              src="../../../assets/images/apartment/bg5.jpg"
              alt=""
            />
            <div
              class="apartment-text wow animate__slideInUp"
              data-wow-delay="100ms"
              data-wow-duration="500ms"
            >
              <img
                src="../../../assets/images/apartment/icon5.png"
                alt=""
              />
              <p>全天管家</p>
              <p>24小时新家级管家式服务</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="section-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">长短租结合的</p>
            <p class="bottom-text-title">酒店式公寓</p>
            <div class="bottom-text-info">
              <p>有限服务型酒店，长租、短租灵活选择</p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">提供小型</p>
            <p class="bottom-text-title">综合商业配套</p>
            <div class="bottom-text-info">
              <p>提供小型综合商业配套（吃、住、娱、购）</p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">提供岗位</p>
            <p class="bottom-text-title">及就业机会</p>
            <div class="bottom-text-info">
              <p>提供新的工作岗位及就业机会，招聘员工主要为周边居民</p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">新希望自创品牌</p>
            <div class="bottom-text-info">
              <p>
                以新希望集团自身的品牌能力、整合能力，整合与洲际酒店集团、希尔顿酒店集团、雅高酒店集团等合作的专业的能力，打造现代、时尚、符合年轻人需求的高品质项目
              </p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">社区服务</p>
            <div class="bottom-text-info">
              <p>洗衣服务、快递服务、家政服务、商品店、咖啡厅、简餐、书吧等</p>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bottom-text-box">
            <p class="bottom-text-title">配套</p>
            <div class="bottom-text-info">
              <p>健身室、娱乐/影音/会议室、社交场所等</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";

export default {
  name: "ApartmentPage",
  data() {
    return {
      swiperList: [
        require('../../../assets/images/apartment/swiper1.png'),
        require('../../../assets/images/apartment/swiper2.png'),
        require('../../../assets/images/apartment/swiper3.png'),
        require('../../../assets/images/apartment/swiper4.png'),
        require('../../../assets/images/apartment/swiper5.png'),
        require('../../../assets/images/apartment/swiper6.png'),
        require('../../../assets/images/apartment/swiper7.png'),
        require('../../../assets/images/apartment/swiper8.png'),
        require('../../../assets/images/apartment/swiper9.png'),
        require('../../../assets/images/apartment/swiper10.png'),
        require('../../../assets/images/apartment/swiper11.png'),
        require('../../../assets/images/apartment/swiper12.png'),
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();

      this.swiper = new Swiper(this.$refs.headerSwiperRef, {
        loop: true,
        slidesPerView: 2,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        spaceBetween: 20,
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    });
  },
  beforeDestroy() {
    this.swiper = null;
  },
};
</script>
<style lang="scss" scoped>
.apartment-container {
  .section-title-line img {
    transform: translateY(-20%);
  }

  .swiper-container {
    margin-top: 40px;
  }

  .swiper-box {
    width: 1110px;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
  }

  .mt65 {
    margin-top: 65px;
  }

  .apartment-box {
    width: 100%;
    position: relative;
    margin-bottom: 20px;

    > img {
      width: 100%;
      height: auto;
    }
  }

  .apartment-text {
    position: absolute;
    width: 200px;
    height: 140px;
    left: 50%;
    top: 50%;
    margin-top: -70px;
    margin-left: -100px;
    text-align: center;
    color: #fff;

    > img {
      width: 50px;
    }

    > p {
      font-size: 12px;
      margin-top: 15px;
    }

    > p:nth-child(2) {
      font-size: 16px;
      margin-top: 30px;
    }
  }

  .bottom-text-box {
    background: #f3f3f4;
    width: 100%;
    height: 100%;
    margin-top: 20px;
    padding: 30px;
    box-sizing: border-box;
  }

  .bottom-text-title {
    font-size: 22px;
    color: #008048;
  }

  .bottom-text-info {
    color: #565c61;
    font-size: 13px;
    max-width: 247px;
    margin-top: 30px;
    height: 100px;
    line-height: 20px;

    > p {
      text-align: justify;
    }
  }

  .swiper-button {
    height: 30px;
    width: 30px;

    &::after {
      font-size: 26px!important;
    }
  }

  .swiper-button-prev.swiper-button {
    left: 0px;
  }

  .swiper-button-next.swiper-button {
    right: 0px;
  }
}
</style>
